export default __webpack_public_path__ + "static/media/hypothesis.8e3d984e.svg";